import React, { useRef, useState } from 'react';
import { Table, Tooltip } from 'antd';
import { getColumnSearchProps } from '../common/TableFilter';
import FlexButton from '../common/FlexButton';
import { useGlobalContext } from '../../App';
import { handleExport } from '../result/ScheduleResult'

export default () => {

    const {
        STIResult,
        setSTIResult,
        result701,
        setResult701,
        result702,
        setResult702,
    } = useGlobalContext();

    // table filter
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    // table columns
    const STIColumns = [
        {
            title: '服務日期', dataIndex: 'service_date', key: 'service_date', width: 120,
            ...getColumnSearchProps('service_date', '服務日期', searchInput, setSearchText, searchText, setSearchedColumn, searchedColumn),
        },
        {
            title: '服務時間', dataIndex: 'service_time', key: 'service_time', width: 120,
            ...getColumnSearchProps('service_time', '服務時間', searchInput, setSearchText, searchText, setSearchedColumn, searchedColumn),
        },
        {
            title: '客戶編號', dataIndex: 'customer_ID', key: 'customer_ID', width: 120, ellipsis: { showTitle: false, },
            ...getColumnSearchProps('customer_ID', '客戶編號', searchInput, setSearchText, searchText, setSearchedColumn, searchedColumn),
        },
        {
            title: '客戶名稱', dataIndex: 'name', key: 'name', width: 120, ellipsis: { showTitle: false, },
            ...getColumnSearchProps('name', '客戶名稱', searchInput, setSearchText, searchText, setSearchedColumn, searchedColumn),
        },
        { title: '集團公司編號', dataIndex: 'company_ID', key: 'company_ID', width: 120, },
        {
            title: '地址', dataIndex: 'address', key: 'address', width: 160, ellipsis: { showTitle: false, },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            ),
        },
        { title: '服務種類', dataIndex: 'type', key: 'type', width: 100, },
        {
            title: '加班備註', dataIndex: 'overtime_remark', key: 'overtime_remark', width: 100, editable: true, ellipsis: { showTitle: false, },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>{text}</Tooltip>
            ),
        },
        {
            title: '技術員', dataIndex: 'staff', key: 'staff', width: 100, editable: true, ellipsis: { showTitle: false, },
            ...getColumnSearchProps('staff', '技術員', searchInput, setSearchText, searchText, setSearchedColumn, searchedColumn),
        },
        { title: '「加班」資料', dataIndex: 'overtime', key: 'overtime', width: 120, },
        { title: '「佣金種類」資料', dataIndex: 'money_type', key: 'money_type', width: 160, },
        { title: '「佣金%」資料', dataIndex: 'money_percent', key: 'money_percent', width: 160, },
        { title: '「服務週期」資料', dataIndex: 'period', key: 'period', width: 160, },
        { title: '「平日」資料', dataIndex: 'weekday', key: 'weekday', width: 120, },
        { title: '黑名單工作人員', dataIndex: 'blacklist', key: 'blacklist', width: 160, editable: true, },
        { title: '重要事項(變更提示) ', dataIndex: 'important', key: 'important', width: 160, editable: true, },
        { title: '於假期不用工作', dataIndex: 'holiday', key: 'holiday', width: 140, editable: true, },
        { title: '工作單編號', dataIndex: 'order_ID', key: 'order_ID', width: 140, },
        { title: '已確認', dataIndex: 'confirmed', key: 'confirmed', width: 140, editable: true, },
        { title: '備註', dataIndex: 'remark', key: 'remark', width: 140, editable: true, },
    ];

    const FogColumns = [
        {title: '日期', dataIndex: 'service_date', key: 'service_date', width: 120,},
        {title: '星期幾', dataIndex: 'service_date_weekday', key: 'service_date_weekday', width: 120,},
        {title: '所安排的當日訂單', dataIndex: 'serviceDescription', key: 'serviceDescription', width: 180,},
    ];

    return (
        <div className="page">
            <h1>排班方案</h1>

            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                <FlexButton text="導出STI全部排班結果" onClick={() => handleExport(STIColumns, STIResult, 'STI全部排班結果')} />
                <div style={{ marginLeft: 16 }}><FlexButton text="導出STI(T701)排班結果" onClick={() => handleExport(FogColumns, result701, 'STI(T701)排班結果')} /></div>
                <div style={{ marginLeft: 16 }}><FlexButton text="導出焗霧(T702)排班結果" onClick={() => handleExport(FogColumns, result702, '焗霧(T702)排班結果')} /></div>
            </div>

            <div className="table-container" style={{ marginTop: '16px' }}>
                <Table
                    style={{ marginTop: '16px' }}
                    bordered
                    scroll={{
                        x: 'calc(800px + 50%)',
                        y: 500,
                    }}
                    columns={STIColumns}
                    dataSource={STIResult}
                    rowClassName={(record, index) => { //0手工固定日期，系统排期
                        return (record.scheduleLevel === 0 ? 'row_background_5' : '')
                    }}
                />
            </div>
        </div>
    );
};
